import React from "react";
import { Button, Grid, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import i18n from "./i18n";

interface WarningMsgDialogProps {
    saveAction: (applySaveAction: boolean, applyToCurrentMonthFlag: boolean) => void;
    show: boolean,
    applyToCurrentMonth: boolean;
    onClose: () => void,
}

// eslint-disable-next-line arrow-body-style
const WarningMsgDialog = ({ show, applyToCurrentMonth, saveAction, onClose }: WarningMsgDialogProps) => {
    return (
        <div>
            <Dialog open={show} onClose={onClose}>
                <DialogTitle>{i18n.warningMsgTitle}</DialogTitle>
                <DialogContent dividers>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography>{i18n.warningMsgForCompanyBudgetChange}</Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => saveAction(false, applyToCurrentMonth)}>{i18n.cancel}</Button>
                    <Button color="primary" onClick={() => saveAction(true, applyToCurrentMonth)}>{i18n.confirm}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default WarningMsgDialog;
